import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=23a39285&scoped=true&"
import script from "./Time.vue?vue&type=script&lang=ts&"
export * from "./Time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a39285",
  null
  
)

export default component.exports